const angular = require('angular')
const detailCtrl = require('./detailCtrl')
const detailService = require('./detailService')
const watermark = require('../../../directives/watermark')

module.exports = angular.module('hxphone.detail', [])
  .factory('detailService', detailService)
  .controller('detailCtrl', detailCtrl)
  .directive('watermark', watermark)



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/detail/module.js